export const modulesList = [
  {
    id: 1,
    name: "user-info"
  },
  {
    id: 2,
    name: "local-admin"
  },
  {
    id: 3,
    name: "modules-tools"
  },
  {
    id: 4,
    name: "datasources"
  }
];

export const userFields = [
  {
    id: 1,
    value: "name",
    type: "string"
  },
  {
    id: 2,
    value: "password",
    type: "password"
  },
  {
    id: 3,
    value: "email",
    type: "email"
  },
  {
    id: 4,
    value: "role_name",
    type: "role_name"
  },
  {
    id: 5,
    value: "valid_until",
    type: "date"
  },
  {
    id: 6,
    value: "admin",
    type: "checkbox"
  }
];

export const userFieldsInfo = [
  {
    id: 1,
    value: "last_name",
    type: "string"
  },
  {
    id: 2,
    value: "first_name",
    type: "string"
  },
  {
    id: 3,
    value: "middle_name",
    type: "string"
  },
  {
    id: 4,
    value: "company",
    type: "string"
  },
  {
    id: 5,
    value: "position",
    type: "string"
  }
];

export const userTemplate = {
  name: "",
  first_name: "",
  last_name: "",
  middle_name: "",
  position_id: "",
  admin: false,
  password: "",
  local_admin: false,
  managed_users: []
};

export const sourcenamesTitles = [
  { prop: "name", label: "Название", type: "string" },
  { prop: "create", label: "C", type: "boolean" },
  { prop: "read", label: "R", type: "boolean" },
  { prop: "update", label: "U", type: "boolean" },
  { prop: "delete", label: "D", type: "boolean" },
  { prop: "share", label: "M", type: "boolean" },
  { prop: "export", label: "E", type: "boolean" }
];

export const crudsArray = [
  { prop: "create", icon: "view", value: false },
  { prop: "read", icon: "reading", value: false },
  { prop: "update", icon: "edit", value: false },
  { prop: "delete", icon: "delete", value: false },
  { prop: "share", icon: "share", value: false },
  { prop: "export", icon: "download", value: false }
];

export const usersRequestConfig = {
  include: {
    managed_users: {
      only: ["id", "user_id", "disabled"]
    }
  }
};
